import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { SearchFilterProvider } from '../hooks/search'

import i18n from './i18n'

import Routes from './routes'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/react-query'

console.log('Initialized i18n', i18n)

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SearchFilterProvider>
          <Routes />
        </SearchFilterProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

export default App
